import { useSelector } from 'react-redux'
//TODO!! becasue logrocket issue!! -
// uncomment this code
// when zoom sdk will work with logrocket
//import ZoomPreview from '../ZoomPreview/ZoomPreview'
import AudioVideoDiagnostics from '../AudioVideoDiagnostics/AudioVideoDiagnostics'
import { VIDRO_PROVIDER } from '../../../consts'

export default function PreCallCheck() {
  const videoProvider = useSelector(state => state.app?.videoProvider)

  return <AudioVideoDiagnostics />
  // return (
  //TODO!! becasue logrocket issue!! -
  // uncomment this code and remove the above line
  // when zoom sdk will work with logrocket
  //   <>
  //     {videoProvider === VIDRO_PROVIDER.ZOOM ? (
  //       <ZoomPreview />
  //     ) : (
  //       <AudioVideoDiagnostics />
  //     )}
  //   </>
  // )
}
